import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=b98a590c&scoped=true&"
import script from "./Inspector.vue?vue&type=script&lang=js&"
export * from "./Inspector.vue?vue&type=script&lang=js&"
import style0 from "./Inspector.vue?vue&type=style&index=0&id=b98a590c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98a590c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98a590c')) {
      api.createRecord('b98a590c', component.options)
    } else {
      api.reload('b98a590c', component.options)
    }
    module.hot.accept("./Inspector.vue?vue&type=template&id=b98a590c&scoped=true&", function () {
      api.rerender('b98a590c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/Inspector.vue"
export default component.exports